import Swiper, { Thumbs, Navigation } from "swiper"
Swiper.use([Thumbs, Navigation])

export default new (class ComicGalleryCarousel {
    constructor() {
        this.sliderWraperSelector = "carousel-comic-gallery-wraper"
        this.sliderContainerSelector = "carousel-comic-gallery"
        this.sliderSmallContainerSelector = "carousel-comic-gallery-small"
        this.sliderNextSelector = "carousel-comic-gallery-next"
        this.sliderPrevSelector = "carousel-comic-gallery-prev"
        this.handler()
    }

    handler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderWraperSelector}`).forEach((item) => {
            let mainSwiper = new Swiper(item.querySelector(`.${this.sliderSmallContainerSelector}`), {
                spaceBetween: 16,
                slidesPerView: 'auto',
                watchSlidesProgress: true,
                centerInsufficientSlides: true,
            });
            let childSwiper = new Swiper(item.querySelector(`.${this.sliderContainerSelector}`), {
                spaceBetween: 16,
                slidesPerView: 1,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                thumbs: {
                    swiper: mainSwiper,
                    autoScrollOffset: 1
                },
            });
        });
    }
})()
